/*!
 * Name: Stadtbibliothek Fürstenfeldbruck 2016 v1.0.0
 * Desc: Scripts for "Stadtbibliothek Fürstenfeldbruck" release 2016
 * Author: Sergej Kutschin/SK
 * Date: 05.04.2016
 * 
 * Copyright 2016 Fabrique D'Images ebusiness GmbH (http://www.fdi.de)
 */
/*
 * ChangeLog:
 * 1.0.0     Initial Release
 */
const MS_BREAKPOINT = 480,
	SM_BREAKPOINT = 700,
	MD_BREAKPOINT = 950,
	LG_BREAKPOINT = 1100,
	XL_BREAKPOINT = 1300;
$(window).load(function() {
	console.info("Home-heading margin adjustment");
	$('#home-heading').each(function() {
		console.log((-$(this).outerHeight() / 2) + "px");
		$(this).css('margin-top', (-$(this).outerHeight() / 2) + "px");
	});
});
$(window).load(function() {
	console.info("Teaser height adjustment");
	var teaserAdjustMediaMS = window.matchMedia("(min-width:" + MS_BREAKPOINT + "px)"),
		teaserAdjustMediaMD = window.matchMedia("(min-width:" + MD_BREAKPOINT + "px)");
	if (teaserAdjustMediaMS.matches) {
		$('.teaser-adjust-height').each(function() {
			var selector = '.content-box';
			if (teaserAdjustMediaMD.matches) {
				selector += ', .teaser-card';
			}
			var cols = $(this).find(selector);
			var maxHeight = 0;
			var previousCss = $(this).attr("style");
			cols.each(function() {
					maxHeight = Math.max(maxHeight, $(this).outerHeight());
					console.log($(this));
					console.log($(this).outerHeight());
					console.log(maxHeight);
				})
				.css('min-height', maxHeight);
			$(this).attr("style", previousCss ? previousCss : "");
		});
	}
});
$(function() {
	console.info("Hide navbar on focus loss");
	$(document).click(function() {
		if ($('#main-menu').hasClass('in')) {
			$('#mobile-menu-toggle').click();
		}
	});
	$('#nav-search').on('show.bs.dropdown', function() {
		if ($('#main-menu').hasClass('in')) {
			$('#mobile-menu-toggle').click();
		}
	});
});
$(function() {
	console.info("Translate LightBox-Labels into German");
	lightbox.option({
		albumLabel: 'Bild %1 von %2'
	});
});
$(function() {
	console.info("Add jQueryASSS");
	$('#nav-search').assss({
		'debug': true,
		'dbpfad': vConfig.db,
		'protokolldb': vConfig.statDb,
		'currlang': "DE",
		'searchfield': "#primary-search-field",
		'gobutton': "#primary-search-submit",
		'typeahead': true,
		'awesome_spinner': true,
		'newpageurl': 'pa_de_suchergebnisse.html',
		'trigger': 'hashtag',
		'content_area': '#search-container',
		'headline_area': 'h1'
	});
});
$(function() {
	console.info("Wrap list-content for different bullet-color");
	$('.cms-content li').wrapInner('<span class="li-content" />');
});
$(function() {
	console.info('Open second level menu on mouse over');
	var teaserAdjustMedia = window.matchMedia("(min-width:" + MD_BREAKPOINT + "px)");
	if (teaserAdjustMedia.matches) {
		$('#main-menu a[data-toggle="dropdown"]').click(function(e) {
			e.stopPropagation();
			e.preventDefault();
		});
		$('#main-menu li.dropdown').mouseenter(function() {
			$(this).find('a[data-toggle="dropdown"]').attr('aria-expanded', 'true');
			$(this).addClass('open');
		}).mouseleave(function() {
			$(this).find('a[data-toggle="dropdown"]').attr('aria-expanded', 'false');
			$(this).removeClass('open');
		})
	}
});
$(function() {
	console.info("Initialise Tooltips");
	var tooltipsMedia = window.matchMedia("(min-width:" + MD_BREAKPOINT + "px)");
	if (tooltipsMedia.matches) {
		$('[data-toggle="tooltip"]').tooltip();
	}
});
$(function() {
	console.info("Focus in on show main search container");
	$('#nav-search').on('shown.bs.dropdown', function() {
		$('#primary-search-field').focus();
	});
});
$(function() {
	console.info("Add some classes to pagination");
	$('.pagination-listen ul').each(function() {
		$(this).addClass('list list-inline');
		$(this).find('li').addClass('list-item list-inline-item');
		$(this).find('li.active a').removeAttr("href");
	});
});
$(function() {
	console.info("Add error and succes classes to forms and validates them");
	var form = $("#kontaktFormular");
	if (form.length == 0) {
		form = $("#medienwunschFormular");
	}
	if (form.length > 0) {
		console.info("ValidateForm");
		form.validate({
			rules: {
				captcha: {
					required: true,
					captcha: true
				},
			},
			errorPlacement: function(error, element) {
				if (!$(element).parent('div').hasClass('has-error')) {
					$(element).parent('div').find('span').remove();
					field = "";
					field = $(element).parent('div').parent('div').find('label').text().replace("*", "").trim();
					if ($(element).attr("id") == "captcha") { //Captcha wird automatisch generiert und hat kein Label das man verwenden kÃ¶nnte 
						field = "Captcha";
					}
					if ($(element).attr("id") == "agb" & !$(element).parent('label').hasClass('has-error')) {
						$(element).parent('label').addClass("has-error");
						$(element).parent('label').append('<!--<span class="form-control-feedback" aria-hidden="true"><i class="fa fa-remove"></i></span>--><span id="helpBlock" class="help-block"><br><i class="fa fa-exclamation-triangle"></i>&nbsp;Zustimmung zum Datenschutz ist erforderlich</span>');
					} else {
						$(element).parent('div').append('<!--<span class="form-control-feedback" aria-hidden="true"><i class="fa fa-remove"></i></span>--><span id="helpBlock" class="help-block"><i class="fa fa-exclamation-triangle"></i>&nbsp;' + field + ' ist erforderlich</span>');
					}
				}
				$(element).parent('div').addClass('has-error');
				$(element).parent('div').addClass('has-feedback');
				$(element).parent('div').find('label').addClass('control-label');
				$(element).parent('div').removeClass('has-success');
			},
			success: function(error, element) {
				if (!$(element).parent('div').hasClass('has-success')) {
					$(element).parent('div').find('span').remove();
					//$(element).parent('div').append('<span class="form-control-feedback" aria-hidden="true"><i class="fa fa-check"></i></span>');
				}
				if ($(element).attr("id") == "agb") {
					$(element).parent('label').removeClass("has-error");
					$(element).parent('label').find('span').not('.custom-control-indicator').remove();
				}
				$(element).parent('div').addClass('has-success');
				$(element).parent('div').addClass('has-feedback');
				$(element).parent('div').removeClass('has-error');
				$(element).parent('div').find('label').removeClass('control-label');
			}
		});
	}
});